export const stats = [
    {
    name: 'Strength Boost',
    type:'abilityScore',
    stat: "strength",
    rarity: "common",
    bonus: 1,
    },
    {
    name: 'Dexterity Boost',
    type:'abilityScore',
    stat: "dexterity",
    rarity: "common",
    bonus: 1,
    },
    {
    name: 'Constitution Boost',
    type:'abilityScore',
    stat: "constitution",
    rarity: "common",
    bonus: 1,
    },
    {
    name: 'Intelligence Boost',
    type:'abilityScore',
    stat: "intelligence",
    rarity: "common",
    bonus: 1,
    },
    {
    name: 'Wisdom Boost',
    type:'abilityScore',
    stat: "wisdom",
    rarity: "common",
    bonus: 1,
    },        
    {
    name: 'Charisma Boost',
    type:'abilityScore',
    stat: "charisma",
    rarity: "common",
    bonus: 1,
    },        
    {            
    name: 'Skill Boost',
    type:'skills',
    stat:'skill',
    rarity:'common',
    bonus:3
    },
    // {
    // name: 'Base Attack Bonus Boost',
    // type:"misc",
    // stat: "BAB",
    // rarity: "common",
    // bonus: 1,
    // },
    {
    name: 'Base Attack Bonus Boost',
    type:"misc",
    stat: "BAB",
    rarity: "common",
    bonus: 0.5,
    },
    {
    name: 'Rare Will Boost',
    type:"misc",
    stat: "will",
    rarity: "rare",
    bonus: 1,
    },
    {
    name: 'Rare Reflex Boost',
    type:"misc",
    stat: "reflex",
    rarity: "rare",
    bonus: 1,
    },
    {
    name: 'Rare Fortitude Boost',
    type:"misc",
    stat: "fortitude",
    rarity: "rare",
    bonus: 1,
    },
    {
    name: 'Rare Base Attack Bonus Boost',
    type:"misc",
    stat: "BAB",
    rarity: "rare",
    bonus: 1,
    },            
    {
    name: 'Meathead',
    type:'abilityScore',
    stat: "constitution",
    rarity: "rare",
    bonus: 2,
    drawback:{type:"mental", amount:-1}
    },
    {
    name: 'Brute',
    type:'abilityScore',
    stat: "strength",
    rarity: "rare",
    bonus: 2,
    drawback:{type:"mental", amount:-1}
    },
    {
    name: 'Quick of Body, Only',
    type:'abilityScore',
    stat: "dexterity",
    rarity: "rare",
    bonus: 2,
    drawback:{type:"mental", amount:-1}
    },
    {
    name: 'Hermit',
    type:'abilityScore',
    stat: "wisdom",
    rarity: "rare",
    bonus: 2,
    drawback:{type:"physical", amount:-1}
    },
    {
    name: 'Book Worm',
    type:'abilityScore',
    stat: "intelligence",
    rarity: "rare",
    bonus: 2,
    drawback:{type:"physical", amount:-1}
    },
    {
    name: 'Pretty Boy',
    type:'abilityScore',
    stat: "charisma",
    rarity: "rare",
    bonus: 2,
    drawback:{type:"physical", amount:-1}
    },
    {            
    name: 'Rare Skill Boost',
    type:'skills',
    stat:'skill',
    rarity:'rare',
    bonus:5
    },
    {
    name: 'Epic Will Boost',
    type:"misc",
    stat: "will",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Reflex Boost',
    type:"misc",
    stat: "reflex",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Fortitude Boost',
    type:"misc",
    stat: "fortitude",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Strength Boost',
    type:"abilityScore",
    stat: "strength",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Skill Boost',
    type:'skills',
    stat:'skill',
    rarity:'epic',
    bonus:7
    },
    {
    name: 'Epic Dexterity Boost',
    type:"abilityScore",
    stat: "dexterity",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Constitution Boost',
    type:"abilityScore",
    stat: "constitution",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Intelligence Boost',
    type:"abilityScore",
    stat: "intelligence",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Wisdom Boost',
    type:"abilityScore",
    stat: "wisdom",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Epic Charisma Boost',
    type:"abilityScore",
    stat: "charisma",
    rarity: "epic",
    bonus: 2,
    },
    {
    name: 'Legendary HD Boost',
    type:"misc",
    stat: "hd",
    rarity: "legendary",
    bonus: 1,
    },
    {
    name: 'Epic Base Attack Bonus Boost',
    type:"misc",
    stat: "BAB",
    rarity: "epic",
    bonus: 1.5,
    },
    {
    name: 'Legendary Strength Boost',
    type:"abilityScore",
    stat: "strength",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Dexterity Boost',
    type:"abilityScore",
    stat: "dexterity",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Constitution Boost',
    type:"abilityScore",
    stat: "constitution",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Intelligence Boost',
    type:"abilityScore",
    stat: "intelligence",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Wisdom Boost',
    type:"abilityScore",
    stat: "wisdom",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Charisma Boost',
    type:"abilityScore",
    stat: "charisma",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Base Attack Bonus Boost',
    type:"misc",
    stat: "BAB",
    rarity: "legendary",
    bonus: 2.5,
    },
    {
    name: 'Unique HD Boost',
    type:"misc",
    stat: "hd",
    rarity: "unique",
    bonus: 2,
    },
    {
    name: 'Legendary Skill Boost',
    type:'skills',
    stat:'skill',
    rarity:'legendary',
    bonus:9
    },
    {
    name: 'Legendary Will Boost',
    type:"misc",
    stat: "will",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Reflex Boost',
    type:"misc",
    stat: "reflex",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Legendary Fortitude Boost',
    type:"misc",
    stat: "fortitude",
    rarity: "legendary",
    bonus: 3,
    },
    {
    name: 'Spell Point Per Level Boost',
    type:'misc',
    stat: "spellpoints",
    rarity: "legendary",
    bonus: 2.5,
    },
    {
        name: 'Spell Point Per Level Boost',
        type:'misc',
        stat: "spellpoints",
        rarity: "unique",
        bonus: 4,   
    },
    {
        name: 'Unique Fortitude Boost',
        type:'misc',
        stat: "fortitude",
        rarity: "unique",
        bonus: 4,   
        drawback:{type:"mental", amount:-1}
    },
    {
        name: 'Unique Will Boost',
        type:'misc',
        stat: "will",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"physical", amount:-1}
    },
    {
        name: 'Unique Reflex Boost',
        type:'misc',
        stat: "reflex",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"mental", amount:-1}
    },
    {
        name: 'Unique Skill Boost',
        type:'skills',
        stat:'skill',
        rarity:'unique',
        bonus:12
    },
    {
        name: 'Unique Base Attack Bonus Boost',
        type:"misc",
        stat: "BAB",
        rarity: "Unique",
        bonus: 3.5,
    },
    {
        name: 'Unique Strength Boost',
        type:"abilityScore",
        stat: "strength",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"mental", amount:-1}
        },
        {
        name: 'Unique Dexterity Boost',
        type:"abilityScore",
        stat: "dexterity",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"mental", amount:-1}
        },
        {
        name: 'Unique Constitution Boost',
        type:"abilityScore",
        stat: "constitution",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"mental", amount:-1}
        },
        {
        name: 'Unique Intelligence Boost',
        type:"abilityScore",
        stat: "intelligence",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"physical", amount:-1}
        },
        {
        name: 'Unique Wisdom Boost',
        type:"abilityScore",
        stat: "wisdom",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"physical", amount:-1}
        },
        {
        name: 'Unique Charisma Boost',
        type:"abilityScore",
        stat: "charisma",
        rarity: "unique",
        bonus: 4,
        drawback:{type:"physical", amount:-1}
        },
    ]

    export const skills = [    
        {skill: 'acrobatics', abilityMod:['dexterity']},
        {skill: 'diplomacy', abilityMod:['charisma']},
        {skill: 'bluff', abilityMod:['charisma']},
        {skill: 'climb', abilityMod:['strength']},
        {skill: 'disableDevice', abilityMod:['dexterity','intelligence']},
        {skill: 'escapeArtist', abilityMod:['dexterity']},
        {skill: 'fly', abilityMod:['dexterity']},
        {skill: 'heal', abilityMod:['wisdom']},
        {skill: 'intimidate', abilityMod:['charisma']},
        {skill: 'perception', abilityMod:['wisdom']},
        {skill: 'senseMotive', abilityMod:['wisdom']},
        {skill: 'spellcraft', abilityMod:['intelligence']},
        {skill: 'stealth', abilityMod:['dexterity']},
        {skill: 'perform', abilityMod:['charisma','dexterity']},
        {skill: 'survival', abilityMod:['wisdom']},
        {skill: 'knowArcana', abilityMod:['intelligence']},
        {skill: 'knowPlanes', abilityMod:['intelligence']},
        {skill: 'knowReligion', abilityMod:['wisdom',"intelligence"]},
        {skill: 'knowNature', abilityMod:['intelligence']},
        {skill: 'craft', abilityMod:['intelligence']},
        {skill: 'swim', abilityMod:['strength']},
    ]

    export const drawbacks = [
        {
            stat:"strength",
            type:"physical",        
        },
        {
            stat:"dexterity",
            type:"physical",        
        },
        {
            stat:"constitution",
            type:"physical",        
        },
        {
            stat:"wisdom",
            type:"mental",        
        },
        {
            stat:"charisma",
            type:"mental",        
        },
        {
            stat:"intelligence",
            type:"mental",        
        },
        
    ]